import IconBase, { type IconProps } from '@yoweb/ui/components/Icon/IconBase';

export const DocumentEmptyIcon = (props: IconProps) => (
  <IconBase {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 2.25A2.75 2.75 0 0 0 4.25 5v14A2.75 2.75 0 0 0 7 21.75h10A2.75 2.75 0 0 0 19.75 19V7.828c0-.73-.29-1.429-.806-1.944l-2.828-2.828a2.75 2.75 0 0 0-1.944-.806H7Zm6.25 1.5H7c-.69 0-1.25.56-1.25 1.25v14c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V8.75H15A1.75 1.75 0 0 1 13.25 7V3.75Zm4.858 3.5H15a.25.25 0 0 1-.25-.25V3.892c.112.058.215.134.306.224l2.828 2.828c.09.091.166.194.224.306Z"
      fill="currentColor"
    />
  </IconBase>
);

export default DocumentEmptyIcon;
